<template lang="pug">
    div
      el-row.labelStyle
        el-col(:span="12")
          app-display(
            label="Cnuc:",
            :content="dadosJson.cadastroUc.informacoesAdministrativasUc.cncu || '-'",
          )
          app-display(
          label="Nome da UC:",
          :content="dadosJson.cadastroUc.informacoesAdministrativasUc.nomeUc || '-'",
          )
          app-display(
            label="Esfera Administrativa:",
            :content="dadosJson.cadastroUc.informacoesAdministrativasUc.esferaAdministrativa || '-'",
          )
        el-col(:span="12")
          app-display(
            label="Objetivo de Criação:",
            :content="dadosJson.cadastroUc.informacoesAdministrativasUc.objetivoCriacaoUc || '-'",
          )
          app-display(
            label="Órgão Gestor:",
            :content="dadosJson.cadastroUc.informacoesAdministrativasUc.orgaoGestor || '-'",
          )
          app-display(
            label="Categoria de Manejo:",
            :content="dadosJson.cadastroUc.informacoesAdministrativasUc.categoriaManejo || '-'",
          )
</template>
  </template>
<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesGeraisRf.vue